import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import useModal from '../../hooks/useModal';
import { classNames } from '../helpers/functions';

const Slider = ({
	name,
	children,
	wide,
	fullWidth,
	form,
	title,
	description,
	onClose,
	forceOpen,
	overlay = true,
}) => {
	const { open, setClose } = useModal(name || '');

	const handleClose = () => {
		if (typeof onClose === 'function') {
			onClose();
		}
		setClose();
	};
	return (
		<Transition.Root show={!!open || !!forceOpen} as={Fragment} appear={true}>
			<Dialog as="div" className="relative z-10" onClose={handleClose}>
				{overlay && (
					<Transition.Child
						as={Fragment}
						enter="ease-in-out duration-500"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="ease-in-out duration-500"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
						appear={true}
					>
						<div className="fixed inset-0 bg-gray-500/75 transition-opacity" />
					</Transition.Child>
				)}

				<div className="fixed inset-0 overflow-hidden">
					<div className="absolute inset-0 overflow-hidden">
						<div
							className={classNames(
								'pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10',
								wide ? 'sm:pl-16' : '',
							)}
						>
							<Transition.Child
								as={Fragment}
								enter="transform transition ease-in-out duration-500 sm:duration-700"
								enterFrom="translate-x-full"
								enterTo="translate-x-0"
								leave="transform transition ease-in-out duration-500 sm:duration-700"
								leaveFrom="translate-x-0"
								leaveTo="translate-x-full"
								appear={true}
							>
								<Dialog.Panel
									className={classNames(
										'pointer-events-auto relative w-screen',
										wide ? 'max-w-2xl' : 'max-w-md',
									)}
								>
									<Transition.Child
										as={Fragment}
										enter="ease-in-out duration-500"
										enterFrom="opacity-0"
										enterTo="opacity-100"
										leave="ease-in-out duration-500"
										leaveFrom="opacity-100"
										leaveTo="opacity-0"
										appear={true}
									>
										<div className="absolute top-0 left-0 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4">
											<button
												type="button"
												className="rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
												onClick={handleClose}
											>
												<span className="sr-only">Close panel</span>
												<XMarkIcon className="h-6 w-6" aria-hidden="true" />
											</button>
										</div>
									</Transition.Child>
									<div
										className={classNames(
											'flex h-full flex-col overflow-y-scroll bg-white shadow-xl',
											form ? '' : 'py-6',
										)}
									>
										{form ? (
											<div className="bg-indigo-700 py-6 px-4 sm:px-6">
												<div className="flex items-center justify-between">
													<Dialog.Title className="text-lg font-medium text-white">
														{title}
													</Dialog.Title>
												</div>
												{description ? (
													<div className="mt-1">
														<p className="text-sm text-indigo-300">
															{description}
														</p>
													</div>
												) : null}
											</div>
										) : (
											<div className="px-4 sm:px-6">
												<Dialog.Title className="text-lg font-medium text-gray-900">
													{title}
												</Dialog.Title>
											</div>
										)}

										<div
											className={classNames(
												'relative mt-6 flex-1 ',
												fullWidth ? 'px-0 sm:px-0' : 'px-4 sm:px-6',
											)}
										>
											{children}
										</div>
									</div>
								</Dialog.Panel>
							</Transition.Child>
						</div>
					</div>
				</div>
			</Dialog>
		</Transition.Root>
	);
};

export default Slider;
